export enum FacebookModalStateTypes {
  FbLoginState = 0,
  AdAccountsState = 1
}
